import React from 'react';
import { Image, ImageProps, ImageSourcePropType, ImageStyle, Platform, StyleProp } from 'react-native';
import { useTheme } from '../../theme/ThemeContext';

const LOGO_LIGHT_NATIVE = require('../../../assets/logo-light.png');
const LOGO_DARK_NATIVE = require('../../../assets/logo-dark.png');

function toImageSource(asset: any): ImageSourcePropType {
  if (typeof asset === 'number') {
    return asset;
  }
  if (typeof asset === 'string') {
    return { uri: asset };
  }
  if (asset && typeof asset === 'object') {
    if (typeof asset.uri === 'string') {
      return asset;
    }
    if (typeof asset.default === 'string') {
      return { uri: asset.default };
    }
    if (asset.default) {
      return toImageSource(asset.default);
    }
  }
  return asset;
}

export function getAppLogoSource(isDark: boolean): ImageSourcePropType {
  if (Platform.OS === 'web') {
    return { uri: isDark ? '/logo-dark.png' : '/logo-light.png' };
  }
  return toImageSource(isDark ? LOGO_DARK_NATIVE : LOGO_LIGHT_NATIVE);
}

export interface AppLogoProps {
  width?: number;
  height?: number;
  style?: StyleProp<ImageStyle>;
  resizeMode?: ImageProps['resizeMode'];
  /** Force a variant when the surrounding surface does not follow the app theme. */
  appearance?: 'light' | 'dark';
}

export const AppLogo: React.FC<AppLogoProps> = ({
  width,
  height,
  style,
  resizeMode = 'contain',
  appearance,
}) => {
  const { isDark } = useTheme();
  const useDark = appearance ? appearance === 'dark' : isDark;

  return (
    <Image
      source={getAppLogoSource(useDark)}
      style={[width != null || height != null ? { width, height } : null, style]}
      resizeMode={resizeMode}
      accessibilityLabel="Leads n Business"
    />
  );
};

export default AppLogo;
